import { render, staticRenderFns } from "./P404.vue?vue&type=template&id=5c03d613&scoped=true"
import script from "./P404.vue?vue&type=script&lang=js"
export * from "./P404.vue?vue&type=script&lang=js"
import style0 from "./P404.vue?vue&type=style&index=0&id=5c03d613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03d613",
  null
  
)

export default component.exports